import { Suspense, lazy } from "react";
import ProtectedRoute from "./ProtectedRoute";

const Loading = (
  <div className="w-full h-[100dvh] flex items-center justify-center bg-gradient-to-b from-slate-900 via-blue-900 to-cyan-700 bg-fixed">
    <p className="text-sm text-white/70">Loading...</p>
  </div>
);

const KakaoLoginRedirectPage = lazy(
  () => import("../pages/member/KakaoLoginRedirectPage"),
);
const KakaoSignUpRedirectPage = lazy(
  () => import("../pages/member/KaKaoSignUpRedirectPage"),
);
const KakaoAgreementPage = lazy(
  () => import("../pages/member/KakaoAgreementPage"),
);
const MyPage = lazy(() => import("../pages/member/MyPage"));

const Withdraw = lazy(() => import("../pages/member/WithdrawAgrrementPage"));

const memberRouter = () => [
  // 공개: 가입/로그인 콜백 플로우
  {
    path: "agreement",
    element: (
      <Suspense fallback={Loading}>
        <KakaoAgreementPage />
      </Suspense>
    ),
  },
  {
    path: "kakao-login",
    element: (
      <Suspense fallback={Loading}>
        <KakaoLoginRedirectPage />
      </Suspense>
    ),
  },
  {
    path: "kakao-signup",
    element: (
      <Suspense fallback={Loading}>
        <KakaoSignUpRedirectPage />
      </Suspense>
    ),
  },
  // 보호: 로그인된 회원 전용
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "my-page",
        element: (
          <Suspense fallback={Loading}>
            <MyPage />
          </Suspense>
        ),
      },
      {
        path: "withdraw",
        element: (
          <Suspense fallback={Loading}>
            <Withdraw />
          </Suspense>
        ),
      },
    ],
  },
];

export default memberRouter;
